
import React from 'react';
import PropTypes from 'prop-types';

const Search = (props) => {
    const handleChange = (event) => {
        props.sort(event.target.value, 'search');
    };

    const handleFocus = (event) => {

    };

    return (
        <div className="filter__search">
            <label for="course-filter-freetext" className="visuallyhidden">{props.placeholder}</label>
            <input
                id="course-filter-freetext"
                name="filter-freetext"
                className='filter__freetext'
                value={props.value}
                onChange={handleChange}
                placeholder={props.placeholder}
                onFocus={handleFocus}
            />
        </div>
    );
};

Search.propTypes = {
    sort: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    placeholder: PropTypes.string
};

export default Search;
